import { cn } from '@/utils/styles';
import { getTimeBasedGreetingAndBgImg } from '@/components/utils/Timezone';
interface HomeGreetingProps {
  userName: string;
  className?: string;
}

export const HomeGreeting = ({
  userName,
  className,
}: HomeGreetingProps) => {
  return (
    <div className={className} data-testid="home-greeting-section">
      <span 
        data-testid="home-greeting-message"
        className={cn(
          "block font-serif typography-body italic",
         
        )}
      >
        {getTimeBasedGreetingAndBgImg().greeting}
      </span>
      <h1 
        data-testid="home-greeting-username"
        className={cn(
          "typography-d1",
          "fs-mask"
        )}
      >
        {userName}
      </h1>
    </div>
  );
};